import type { Notification } from '@starly/starly-types';
import { createReducer } from '@reduxjs/toolkit';
import {
  notificationLogoutReset, notificationsLoad,
  notificationsLoading,
  notificationsMoreToLoad,
  notificationsResponse, notificationsSetDelayRequest, notificationsSetIsOpen,
  notificationsSetPage,
  notificationsUnreadResponse,
  removeNotification,
  resetNotifications,
} from './notificationsActions';
import type { DocumentSnapshot } from '../../global/firebase';

export interface NotificationsSlice {
  notifications: Notification[],
  isLoading: boolean,
  isLoad: boolean,
  unread: number,
  hasMoreToLoad: boolean,
  isNotificationsOpen: boolean,
  isDelayRequest: boolean,
  page: DocumentSnapshot | null,
}

const initialState: NotificationsSlice = {
  notifications: [],
  isLoading: false,
  isLoad: false,
  isNotificationsOpen: false,
  isDelayRequest: false,
  hasMoreToLoad: true,
  unread: 0,
  page: null,
};

const notificationsReducer = createReducer<NotificationsSlice>(initialState, (builder) => {
  builder.addCase(notificationsResponse, (state, { payload: { notifications } }) => {
    state.notifications.push(...notifications);
  });
  builder.addCase(notificationsLoad, (state, { payload: { isLoad } }) => {
    state.isLoad = isLoad;
  });
  builder.addCase(notificationsMoreToLoad, (state, { payload: { hasMoreToLoad } }) => {
    state.hasMoreToLoad = hasMoreToLoad;
  });
  builder.addCase(notificationsLoading, (state, { payload: { isLoading } }) => {
    state.isLoading = isLoading;
  });
  builder.addCase(notificationsSetPage, (state, { payload: { page } }) => {
    state.page = page;
  });
  builder.addCase(notificationsUnreadResponse, (state, { payload: { unread } }) => {
    state.unread = unread;
  });
  builder.addCase(removeNotification, (state, { payload: { notification } }) => {
    const notificationDate = notification.create_time.toDate();
    for (let i = 0; i < state.notifications.length; i += 1) {
      if (state.notifications[i].create_time.getTime() === notificationDate.getTime()
        && state.notifications[i].type === notification.type) {
        state.notifications.splice(i, 1);
        state.unread -= 1;
      }
      if (state.notifications[i].create_time <= notificationDate) {
        break;
      }
    }
  });
  builder.addCase(resetNotifications, (state) => {
    state.notifications = [];
    state.page = null;
    state.isLoading = false;
    state.isLoad = false;
    state.hasMoreToLoad = true;
  });
  builder.addCase(notificationsSetIsOpen, (state, { payload: { isOpen } }) => {
    state.isNotificationsOpen = isOpen;
  });
  builder.addCase(notificationsSetDelayRequest, (state, { payload: { isDelayRequest } }) => {
    state.isDelayRequest = isDelayRequest;
  });
  builder.addCase(notificationLogoutReset, (state) => {
    state.notifications = [];
    state.page = null;
    state.isLoading = false;
    state.isLoad = false;
    state.hasMoreToLoad = true;
    state.isDelayRequest = false;
    state.unread = 0;
  });
});

export default notificationsReducer;
